import { Stack } from '@mui/material';
import { SxProps } from '@mui/system';
import React from 'react';

export const CenterCellContainer = ({ children, additionalSx }: { children: React.ReactNode, additionalSx?: SxProps }) => {
  return <Stack width='100%' height='100%' justifyContent='center' alignItems='center' direction='row' sx={additionalSx}>{children}</Stack>;
};
